import React from "react";
import PropTypes from "prop-types";
import Button from "../wrappers/Button";
import LoadingButton from "../wrappers/LoadingButton";
import Stack from "../wrappers/Stack";
import Icon from "../Icon";

/**
 * Apresenta as ações globais de limpar e aplicar filtros.
 *
 * @param {object} pProps Propriedades do componente.
 * @param {Function} pProps.onClear Callback para limpar o rascunho.
 * @param {Function} pProps.onApply Callback para aplicar o rascunho.
 * @param {string} [pProps.clearLabel="Limpar filtros"] Rótulo da ação de limpar.
 * @param {string} [pProps.applyLabel="Aplicar filtros"] Rótulo da ação de aplicar.
 * @param {boolean} [pProps.applyDisabled=false] Impede a aplicação dos filtros.
 * @param {boolean} [pProps.loading=false] Indica aplicação em andamento.
 * @returns {React.ReactElement}
 */
const SearchFiltersActions = (pProps) => {
  const {
    onClear,
    onApply,
    clearLabel = "Limpar",
    applyLabel = "Aplicar",
    applyDisabled = false,
    loading = false,
  } = pProps;

  /** Impede a chamada programática quando a aplicação estiver bloqueada. */
  const pvHandleApply = () => {
    if (applyDisabled || loading) {
      return;
    }

    onApply();
  };

  return (
    <Stack direction="row" justifyContent="flex-end" spacing={1}>
      <Button disabled={loading} onClick={onClear} type="button" variant="text" size="small">
        {clearLabel}
      </Button>
      <LoadingButton
        disabled={applyDisabled || loading}
        loading={loading}
        onClick={pvHandleApply}
        type="button"
        variant="contained"
        size="small"
        color="primary"
        // startIcon={<Icon iconName="search" size={16} color="secondary" />}
        sx={{
          px: 2,
        }}
      >
        {applyLabel}
      </LoadingButton>
    </Stack>
  );
};

SearchFiltersActions.propTypes = {
  onClear: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  clearLabel: PropTypes.string,
  applyLabel: PropTypes.string,
  applyDisabled: PropTypes.bool,
  loading: PropTypes.bool,
};

export default SearchFiltersActions;
